import React from "react";

import {useWeather} from "../contextprovider/weather";



const Btn = ()=>{
    const myweather = useWeather();
    return (
        <button onClick={myweather.fetchData}>Submit</button>
    );
}


export default Btn;